<template>
  <div>
    <h5 class="font-blue">Haz una pregunta</h5>
    <div class="mt-4">
      <b-form-input
        v-model="title.val"
        type="text"
        :state="title.valid"
        :disabled="loading"
        required
        placeholder="Escribe título de tu pregunta"
      ></b-form-input>
      <br>
      <b-form-textarea
        :state="question.valid"
        :disabled="loading"
        v-model="question.val"
        placeholder="Escribe tu pregunta..."
        rows="3"
        max-rows="6"
      ></b-form-textarea>
      <b-button @click="sendQuestion" :disabled="loading" class="mt-3 b-orange shadow-sm">
        <b-spinner v-if="loading" small></b-spinner>
        <i v-if="!loading" class="fas fa-paper-plane"></i> Enviar pregunta
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      title: {
        val: "",
        valid: null
      },
      question: {
        val: "",
        valid: null
      }
    };
  },
  props: {
    course: Object
  },
  methods: {
    verifyInputs() {
      let title = this.title.val.trim();
      let question = this.question.val.trim();

      if (title != "" && title != null && title != undefined) {
        this.title.valid = true;
      } else {
        this.title.valid = false;
      }

      if (question != "" && question != null && question != undefined) {
        this.question.valid = true;
      } else {
        this.question.valid = false;
      }
    },
    sendQuestion() {
      this.loading = true;
      this.verifyInputs();
      if (this.title.valid && this.question.valid) {
        let url = "course/" + this.course.id + "/questions";
        this.api
          .post(url, {
            data: {
              course_id: this.course.id,
              title: this.title.val,
              question: this.question.val
            }
          })
          .then(({ data }) => {
            this.loading = false;
            if (data.insertion) {
              this.bus.$emit("UpdateQuestions", data.data_return);
              this.title = {
                val: "",
                valid: null
              };
              this.question = {
                val: "",
                valid: null
              };
            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      }else{
          this.loading = false;
      }
    }
  }
};
</script>
<style scoped>
.input-question {
  background: #f0f1f3 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/#public/curse/components/content/CreateQuestion.vue